/* eslint-disable max-len */
import { useMediaQuery } from "@mui/material";
import { LogoutIcon } from "../assets/Icons";
import * as Axios from "../providers/axios";
import * as User from "../providers/user";
import { Theme } from "@emotion/react";

interface ImpersonateHeaderProps {
  fixedWidth?: boolean;
  open?: boolean;
  customClasses?: {
    container?: string;
    message?: string;
  };
}

const ImpersonateHeader: React.FC<ImpersonateHeaderProps> = ({
  fixedWidth = false,
  customClasses = {},
  open = false
}) => {
  const { api } = Axios.useAxios();
  const { user } = User.useUser();
  const isMedium = useMediaQuery<Theme>("(max-width:1024px)");

  const containerStyle = fixedWidth
    ? {}
    : {
        width: open
          ? `calc(100% - ${isMedium ? 190 : 248}px)`
          : "calc(100% - 64px)"
      };

  const onLogout = async () => {
    localStorage.removeItem("ServiceCalendarLocationFilter");
    localStorage.removeItem("ServiceCalendarDateFilter");
    localStorage.removeItem("RaStore.Availability.listParams");
    try {
      await api.post("v1/companies/impersonate-logout");

      window.location.reload();
    } catch (error) {
      throw new Error("Error logging out: " + error.message);
    }
  };

  return (
    <div
      className={`bg-[#F8D1C0] flex justify-between items-center px-4 py-[8px] ${
        customClasses.container || ""
      }`}
      style={containerStyle}
    >
      <div
        className={`text-[14px] text-[#752D0D] ${customClasses.message || ""}`}
      >
        You are logged in as super-admin of the company:{" "}
        {user.impersonate_company_name}
      </div>
      <div
        className={"flex w-[80px] items-center gap-[14px] group cursor-pointer"}
        onClick={onLogout}
        aria-hidden
      >
        <LogoutIcon fill="#752D0D" />
        <span
          className={
            "text-[13px] font-normal font-['Inter'] whitespace-nowrap group-hover:!text-mono-black"
          }
          style={{ color: "#752D0D" }}
        >
          Log out
        </span>
      </div>
    </div>
  );
};

export default ImpersonateHeader;
